//MODEL: custom model object : { domain: instance of Domain }

define('app/editor/dialogs/ColumnMenuConfirmationDialogView',['require','glu/itemView','glu/dialog','glu/$','glu/store','hbs!./ColumnMenuConfirmationDialogView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		dialog = require('glu/dialog'),
		$ = require('glu/$'),
		store = require('glu/store');

	return ItemView.extend({

		template: require('hbs!./ColumnMenuConfirmationDialogView.hbs'),

		ui: {
			$searchTxt: '[name=searchTxt]'
		},

		events: {
			'submit form': 'submitForm',
			'keyup [name="searchTxt"]': 'updateView',
			'click [type="checkbox"]': 'toggleFilterOptions',
			'change [name=value]': 'updateModel'
		},

		getClass: function() {
			return this.className || 'modal-confirm';
		},

		initialize: function() {
			this.dialogTitle = this.options.dialogTitle;
			this.dialogButtons = [{
				text: 'Yes',
				callback: this[this.options.callback],
				className: 'btn-primary'
			}, {
				text: 'No',
				callback: 'no',
				className: 'btn-default'
			}];

			this.dialogContent = this.options.dialogContent;
		},

		setAsAggregate: function() {
			var self = this;

			// Enable aggregation mode if it isn't already enabled
			self.options.report.setGroupedAndAggregated(true);
			$('#report-definition').children().first().toggleClass('is-grouping-hidden', false);
			$('#group-and-aggregate-checkbox').prop('checked', false);

			// Move to aggregate column
			self.options.report.moveColumnToCategory(self.model.cid, 'aggregated');
			self.options.model.setAsName(self.options.model.getAggregation() + '(' + self.options.model.fieldName() + ')');

			this.checkSkipColumnMenuConfirmationDialogCheckbox();

			dialog.close();
			self.appBus.trigger('refresh');
		},

		setAsGroup: function() {
			var self = this;

			self.options.report.setGroupedAndAggregated(true);
			self.options.report.setAllColumnsToAggregate();

			$('#report-definition').children().first().toggleClass('is-grouping-hidden', false);
			$('#group-and-aggregate-checkbox').prop('checked', false);
			self.options.model.setAsName(self.options.model.fieldName());

			// Move to group column
			self.options.report.moveColumnToCategory(self.model.cid, 'grouped');

			this.checkSkipColumnMenuConfirmationDialogCheckbox();

			dialog.close();
			self.appBus.trigger('refresh');
		},

		setAsUngrouped: function() {
			var self = this;

			self.options.report.setGroupedAndAggregated(false);

			$('#report-definition').children().first().toggleClass('is-grouping-hidden', true);
			$('#group-and-aggregate-checkbox').prop('checked', true);
			self.options.model.setAsName(self.options.model.fieldName());

			this.checkSkipColumnMenuConfirmationDialogCheckbox();

			dialog.close();
			self.appBus.trigger('refresh');
		},

		no: function() {
			dialog.close();
		},

		checkSkipColumnMenuConfirmationDialogCheckbox: function() {
			var checkbox = this.$el.find('#dont-show-checkbox').prop('checked');

			if (checkbox) {
				store.set('skipColumnMenuConfirmationDialog', true);
			}
		},

		serializeData: function() {
			return this;
		}
	});
});

